const SISR_TOKEN = "SISR_TOKEN";
const SISR_DARK_MODE = "SISR_DARK_MODE";

export { SISR_TOKEN, SISR_DARK_MODE };
